"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getObjectToId = exports.reducerQueryUser = exports.reducerQueryProduct = void 0;
var reducer_product_1 = require("./reducer-product");
Object.defineProperty(exports, "reducerQueryProduct", { enumerable: true, get: function () { return reducer_product_1.reducerQueryProduct; } });
var reducer_user_1 = require("./reducer-user");
Object.defineProperty(exports, "reducerQueryUser", { enumerable: true, get: function () { return reducer_user_1.reducerQueryUser; } });
var functions_1 = require("./functions");
Object.defineProperty(exports, "getObjectToId", { enumerable: true, get: function () { return functions_1.getObjectToId; } });
__exportStar(require("./actions-product"), exports);
__exportStar(require("./actions-user"), exports);
//# sourceMappingURL=index.js.map